import { render, staticRenderFns } from "./teacherSet.vue?vue&type=template&id=c844b928"
import script from "./teacherSet.vue?vue&type=script&lang=js"
export * from "./teacherSet.vue?vue&type=script&lang=js"
import style0 from "./teacherSet.vue?vue&type=style&index=0&id=c844b928&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports